"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelFieldHeight = exports.ModelMutatorHeight = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var multipoint_1 = require("../../../math/multipoint");
var unit_1 = require("../../../unit");
var collection_field_1 = require("../collection.field");
var marker_drawable_1 = require("../drawable/marker.drawable");
var ModelMutatorHeight = /** @class */ (function (_super) {
    tslib_1.__extends(ModelMutatorHeight, _super);
    function ModelMutatorHeight() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Remove the state of this drawable
     * *Warning:* You will need to unlink & remove the drawable from the list before destroying the state.
     * @see CollectionModelDrawableStateMutator.remove
     */
    ModelMutatorHeight.prototype.destroyState = function () {
        this.state.setFieldValue(this.field.id, null);
    };
    ModelMutatorHeight.prototype.clear = function () {
        this.manual(null);
    };
    ModelMutatorHeight.prototype.manualFromInput = function (newValue) {
        var stateValue = this.field.stateValue;
        if (!newValue || isNaN(newValue) || !stateValue) {
            this.unlink();
            this.state.setFieldValue(this.field.id, null);
        }
        else {
            var drawableState = this.field.collection.getDrawableState(stateValue.captureId);
            var drawable = drawableState.getDrawable(stateValue.drawable);
            var _a = drawable.calculateM2Px(newValue), x = _a.x, y = _a.y;
            drawable.moveNoBounds(x, y);
        }
    };
    ModelMutatorHeight.prototype.manual = function (newValue) {
        if (this.field.isPhotoMeasure()) {
            this.unlink();
        }
        if (newValue == null || isNaN(newValue)) {
            this.state.setFieldValue(this.field.id, null);
        }
        else {
            this.state.setFieldValue(this.field.id, {
                provider: CollectionModelFieldHeight.PROVIDER_MANUAL,
                value: newValue
            });
        }
    };
    ModelMutatorHeight.prototype.spanHeight = function (captureIds) {
        if (this.field.isPhotoMeasure()) {
            this.unlink();
        }
        if (!Array.isArray(captureIds)) {
            throw new Error("Field ".concat(this.field.id, ": Invalid capture state."));
        }
        if (captureIds.length !== 2) {
            throw new Error("Field ".concat(this.field.id, ": Invalid capture count \"").concat(captureIds.length, "\"."));
        }
        this.state.setFieldValue(this.field.id, {
            provider: CollectionModelFieldHeight.PROVIDER_SPAN_HEIGHT,
            captures: captureIds.slice()
        });
    };
    ModelMutatorHeight.prototype.drawable = function (drawable, isManual) {
        var _this = this;
        if (isManual === void 0) { isManual = false; }
        if (this.field.isPhotoMeasure() || this.field.isPhotoMeasureManual() && !isManual) {
            this.unlink();
        }
        this.state.setFieldValue(this.field.id, {
            provider: isManual ? CollectionModelFieldHeight.PROVIDER_PHOTO_MEASURE_MANUAL : CollectionModelFieldHeight.PROVIDER_PHOTO_MEASURE,
            drawable: drawable.id,
            captureId: drawable.captureId
        });
        if (!drawable.label.links.some(function (link) { return link.id === _this.field.id; })) {
            drawable.label.linkHeight(this.field);
        }
    };
    ModelMutatorHeight.prototype.unlink = function () {
        var stateValue = this.field.stateValue;
        // Only unlink if currently linked.
        if (!(stateValue === null || stateValue === void 0 ? void 0 : stateValue.drawable)) {
            return;
        }
        this.destroyState();
        if (stateValue == null || stateValue.drawable == null || stateValue.captureId == null) {
            return;
        }
        var drawableState = this.field.collection.getDrawableState(stateValue.captureId);
        if (drawableState.hasDrawable(stateValue.drawable)) {
            var drawable = drawableState.getDrawable(stateValue.drawable);
            drawable.label.unlink(this.field.id);
        }
    };
    ModelMutatorHeight.prototype.copy = function (from) {
        var _a, _b;
        if (from.isManual()) {
            this.manual(from.value);
            return true;
        }
        if (from.isSpanHeight()) {
            var state = from.getCaptures().map(function (capture) { return capture.objectId; });
            this.spanHeight(state);
            return true;
        }
        if (from.isPhotoMeasure() || from.isPhotoMeasureManual()) {
            var fromCollection = from.collection;
            var toCollection = this.field.collection;
            var captureId = (_a = from.stateValue) === null || _a === void 0 ? void 0 : _a.captureId;
            if (!captureId || !((_b = from.stateValue) === null || _b === void 0 ? void 0 : _b.drawable)) {
                return false;
            }
            var drawable_1 = fromCollection.getDrawableState(captureId).getDrawable(from.stateValue.drawable);
            if (fromCollection === toCollection) {
                // Link field to existing marker
                drawable_1.label.linkHeight(this.field);
                this.drawable(drawable_1);
                return true;
            }
            if (drawable_1.label.links.length > 1) {
                var existingNewDrawable = toCollection.getDrawableState(captureId).getAllDrawables()
                    .filter(function (d) {
                    return d instanceof marker_drawable_1.CollectionModelDrawableMarker
                        && d.y === drawable_1.y;
                })[0];
                if (existingNewDrawable) {
                    existingNewDrawable.label.linkHeight(this.field);
                    this.drawable(existingNewDrawable);
                    return true;
                }
            }
            // Create a new marker
            var toDrawableState = toCollection.getDrawableState(captureId);
            var newDrawable = drawable_1.clone(toDrawableState);
            this.drawable(newDrawable);
            if (toDrawableState.base == null) {
                this.copyBaseMarkers(fromCollection, captureId);
            }
            return true;
        }
        return false;
    };
    // duplicated in vertical.separation.field.ts
    ModelMutatorHeight.prototype.copyBaseMarkers = function (fromCollection, captureId) {
        var collection = this.field.collection;
        var drawableState = collection.getDrawableState(captureId);
        var fromDrawableState = fromCollection.getDrawableState(captureId);
        var fromBaseMarker = fromDrawableState.base;
        if (fromBaseMarker != null) {
            var baseMarker = marker_drawable_1.CollectionModelDrawableMarker.createWithLabel(drawableState, fromBaseMarker.getVector(), fromBaseMarker.label.getVector(), undefined, core_api_1.MarkerType.BASE).marker;
            var fromBaseOffsetMarker = fromDrawableState.baseOffset;
            if (fromBaseOffsetMarker != null) {
                baseMarker.offset = fromBaseMarker.offset;
            }
        }
    };
    return ModelMutatorHeight;
}(collection_field_1.ModelMutator));
exports.ModelMutatorHeight = ModelMutatorHeight;
var CollectionModelFieldHeight = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionModelFieldHeight, _super);
    function CollectionModelFieldHeight() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CollectionModelFieldHeight.isHeightField = function (f) {
        return f.schema.type === CollectionModelFieldHeight.TYPE;
    };
    Object.defineProperty(CollectionModelFieldHeight.prototype, "Mutator", {
        get: function () {
            if (this._Mutator == null) {
                this._Mutator = new ModelMutatorHeight(this);
            }
            return this._Mutator;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelFieldHeight.prototype, "value", {
        /* computed */
        get: function () {
            var stateValue = this.stateValue;
            if (stateValue == null) {
                return null;
            }
            if (stateValue.provider === CollectionModelFieldHeight.PROVIDER_MANUAL) {
                return stateValue.value;
            }
            if (stateValue.provider === CollectionModelFieldHeight.PROVIDER_SPAN_HEIGHT) {
                var p2pMeasurement = multipoint_1.MultiPoint.Points(this.getCaptures());
                return Math.abs(p2pMeasurement.vertical);
            }
            if (stateValue.provider === CollectionModelFieldHeight.PROVIDER_PHOTO_MEASURE) {
                return this.drawable.value;
            }
            if (stateValue.provider === CollectionModelFieldHeight.PROVIDER_PHOTO_MEASURE_MANUAL) {
                return this.drawable.value;
            }
            throw new Error("Field ".concat(this.id, ": Invalid Provider type \"").concat(stateValue.provider, "\""));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelFieldHeight.prototype, "annotationLabel", {
        get: function () {
            //if we're self-title no need to search for field just return displayname
            var fieldId = this.schema.annotationLabelFieldId;
            if (fieldId === this.schema.id) {
                return this.schema.displayName;
            }
            var field = this.findAncestorField(this.parent, fieldId);
            if (!field || !field.schema.type) {
                return this.parent.title;
            }
            switch (field.schema.type) {
                case core_api_1.IkeFieldType.ANCHOR:
                    // I think to get the complex values we have to type them first and put them together ourselves
                    if (field.hasValue()) {
                        var anchor = field.value;
                        return "".concat(anchor.collectionTool, " ").concat(anchor.placement);
                    }
                    return field.schema.displayName;
                case core_api_1.IkeFieldType.DATE:
                    var date = field;
                    if (!date.hasValue() || date.displayValue == null || date.displayValue === '') {
                        return this.parent.title;
                    }
                    return date.displayValue;
                case core_api_1.IkeFieldType.FILE_TOOL:
                    var fileTool = field;
                    if (!fileTool.hasValue() || fileTool.displayValue == null || fileTool.displayValue === '') {
                        return this.parent.title;
                    }
                    return fileTool.displayValue;
                case core_api_1.IkeFieldType.FORM:
                    return field.schema.displayName;
                case core_api_1.IkeFieldType.HEIGHT:
                    return field.schema.displayName;
                case core_api_1.IkeFieldType.IMAGE:
                    return field.schema.displayName;
                case core_api_1.IkeFieldType.LOCATION:
                    var loc = field;
                    if (!loc.hasValue() || loc.displayValue == null || loc.displayValue === '') {
                        return this.parent.title;
                    }
                    var locVal = loc.value;
                    return "".concat(locVal.latitude.toFixed(2), ",").concat(locVal.longitude.toFixed(2));
                case core_api_1.IkeFieldType.NESTED_LIST:
                    if (!field.hasValue() || field.displayValue == null || field.displayValue === '') {
                        return this.parent.title;
                    }
                    return field.displayValue;
                case core_api_1.IkeFieldType.NUMBER:
                    if (!field.hasValue() || field.displayValue == null || field.displayValue === '') {
                        return this.parent.title;
                    }
                    return field.displayValue;
                case core_api_1.IkeFieldType.SELECT_LIST:
                    if (!field.hasValue() || field.displayValue == null || field.displayValue === '') {
                        return this.parent.title;
                    }
                    return field.displayValue;
                case core_api_1.IkeFieldType.TEXT:
                    if (!field.hasValue() || field.displayValue == null || field.displayValue === '') {
                        return this.parent.title;
                    }
                    return field.displayValue;
                case core_api_1.IkeFieldType.TRUE_SIZE:
                    return field.schema.displayName;
                case core_api_1.IkeFieldType.VECTOR:
                    var vector = field.value;
                    if (field.hasValue()) {
                        return "".concat(unit_1.IkeUnit.display(vector.distance, this.distanceUnit, unit_1.IkeUnit.METER, core_api_1.IkeUnitType.DISTANCE, 1), " ").concat(unit_1.IkeUnit.display(vector.bearing, unit_1.IkeUnit.DEGREE, unit_1.IkeUnit.RADIAN, core_api_1.IkeUnitType.ANGLE, 1));
                    }
                    return field.schema.displayName;
                case core_api_1.IkeFieldType.VERTICAL_SEPARATION:
                    return field.schema.displayName;
                case core_api_1.IkeFieldType.YES_NO:
                    return field.schema.displayName;
                default:
                    return this.parent.title;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelFieldHeight.prototype, "drawable", {
        get: function () {
            var drawableState = this.collection.getDrawableState(this.stateValue.captureId);
            return drawableState.getDrawable(this.stateValue.drawable);
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelFieldHeight.prototype.hasValue = function () {
        var stateValue = this.stateValue;
        if (stateValue == null) {
            return false;
        }
        return true;
    };
    Object.defineProperty(CollectionModelFieldHeight.prototype, "provider", {
        get: function () {
            var stateValue = this.stateValue;
            if (stateValue == null || stateValue.provider == null) {
                return CollectionModelFieldHeight.PROVIDER_MANUAL;
            }
            return stateValue.provider;
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelFieldHeight.prototype.isManual = function () {
        return this.provider === CollectionModelFieldHeight.PROVIDER_MANUAL;
    };
    CollectionModelFieldHeight.prototype.isPhotoMeasure = function () {
        return this.provider === CollectionModelFieldHeight.PROVIDER_PHOTO_MEASURE;
    };
    CollectionModelFieldHeight.prototype.isPhotoMeasureManual = function () {
        return this.provider === CollectionModelFieldHeight.PROVIDER_PHOTO_MEASURE_MANUAL;
    };
    CollectionModelFieldHeight.prototype.isSpanHeight = function () {
        return this.provider === CollectionModelFieldHeight.PROVIDER_SPAN_HEIGHT;
    };
    CollectionModelFieldHeight.prototype.getMeasurements = function () {
        if (!this.isPhotoMeasure()) {
            return [];
        }
        var stateValue = this.stateValue;
        if (stateValue == null) {
            return [];
        }
        return [{
                captureId: stateValue.captureId,
                drawableId: stateValue.drawable
            }];
    };
    CollectionModelFieldHeight.prototype.getOwnedCaptures = function () {
        var _this = this;
        var _a, _b;
        if (!this.isSpanHeight()) {
            return [];
        }
        var stateValue = this.stateValue;
        if (stateValue == null) {
            return [];
        }
        return (_b = (_a = stateValue.captures) === null || _a === void 0 ? void 0 : _a.map(function (c) { return _this.collection.state.getCapture(c); }).filter(function (c) { return !!c; })) !== null && _b !== void 0 ? _b : [];
    };
    CollectionModelFieldHeight.prototype.getCaptures = function () {
        var _this = this;
        return this.getCaptureIds().map(function (c) { return _this.collection.state.getCapture(c); }).filter(function (c) { return !!c; });
    };
    CollectionModelFieldHeight.prototype.getOwnedCaptureIds = function () {
        var _a;
        if (!this.isSpanHeight()) {
            return [];
        }
        var stateValue = this.stateValue;
        if (stateValue == null) {
            return [];
        }
        return (_a = stateValue.captures) !== null && _a !== void 0 ? _a : [];
    };
    CollectionModelFieldHeight.prototype.getCaptureIds = function () {
        var _a, _b, _c;
        if (this.isPhotoMeasure()) {
            return ((_a = this.stateValue) === null || _a === void 0 ? void 0 : _a.captureId) ? [(_b = this.stateValue) === null || _b === void 0 ? void 0 : _b.captureId] : [];
        }
        if (!this.isSpanHeight()) {
            return [];
        }
        var stateValue = this.stateValue;
        if (stateValue == null) {
            return [];
        }
        return (_c = stateValue.captures) !== null && _c !== void 0 ? _c : [];
    };
    CollectionModelFieldHeight.PROVIDER_MANUAL = 'manual';
    CollectionModelFieldHeight.PROVIDER_SPAN_HEIGHT = 'spanheight';
    CollectionModelFieldHeight.PROVIDER_PHOTO_MEASURE = 'photomeasure';
    CollectionModelFieldHeight.PROVIDER_PHOTO_MEASURE_MANUAL = 'photomeasuremanual';
    CollectionModelFieldHeight.TYPE = core_api_1.IkeFieldType.HEIGHT;
    return CollectionModelFieldHeight;
}(collection_field_1.CollectionModelField));
exports.CollectionModelFieldHeight = CollectionModelFieldHeight;
//# sourceMappingURL=height.field.js.map